




import { Component, Vue, Watch } from 'vue-property-decorator';
import { EOnboardingMeetingStatus } from '@/models/onboarding-call';
import ToBeScheduledBar from './ToBeScheduledBar.vue';
import ScheduledBar from './ScheduledBar.vue';
import DoneBar from './DoneBar.vue';
import segmentIo from '@/utils/segment.io';
import {
  getMerchantMeetingOboardingState,
  removeMerchantMeetingOboardingState
} from '@/router/router-utils';
import DateUtils from '@/utils/DateUtils';

@Component({
  components: {
    ToBeScheduledBar,
    ScheduledBar,
    DoneBar
  }
})
export default class ScheduleOnboardingBar extends Vue {
  status = EOnboardingMeetingStatus.PENDING;

  dateTime = '';

  get mapper(): Record<EOnboardingMeetingStatus, { component: string }> {
    return {
      [EOnboardingMeetingStatus.PENDING]: {
        component: 'ToBeScheduledBar'
      },
      [EOnboardingMeetingStatus.CANCELED]: {
        component: 'ToBeScheduledBar'
      },
      [EOnboardingMeetingStatus.NOSHOW]: {
        component: 'ToBeScheduledBar'
      },
      [EOnboardingMeetingStatus.RESCHEDULED]: {
        component: 'ScheduledBar'
      },
      [EOnboardingMeetingStatus.SCHEDULED]: {
        component: 'ScheduledBar'
      },
      [EOnboardingMeetingStatus.COMPLETED]: {
        component: 'DoneBar'
      }
    };
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  @Watch('business')
  changedBusiness() {
    this.setStatus();
  }

  updateValue() {
    if (
      getMerchantMeetingOboardingState() &&
      this.business.onboardingMeeting.status ===
        EOnboardingMeetingStatus.PENDING
    ) {
      this.status = EOnboardingMeetingStatus.SCHEDULED;
      this.dateTime = DateUtils.formattedDate({
        date: getMerchantMeetingOboardingState().datetime,
        format: 'MMM D, YYYY - hh:mm A',
        applyTimezone: true
      });
      removeMerchantMeetingOboardingState();
      segmentIo.track('Rendered Onboarding Call Banner', {
        Status: this.status
      });
    }
  }

  setStatus() {
    const onboardingState = getMerchantMeetingOboardingState();

    if (onboardingState) {
      this.status = EOnboardingMeetingStatus.SCHEDULED;
    } else {
      this.status = this.business.onboardingMeeting.status;
    }
  }

  mounted() {
    window.addEventListener('storage', this.updateValue);
  }

  beforeDestroy() {
    window.removeEventListener('storage', this.updateValue);
  }

  created() {
    const onboardingState = getMerchantMeetingOboardingState();

    this.setStatus();

    this.dateTime = DateUtils.formattedDate({
      date:
        (onboardingState && onboardingState.datetime) ||
        this.business.onboardingMeeting.date,
      format: 'MMM D, YYYY - hh:mm A',
      applyTimezone: true
    });
    segmentIo.track('Rendered Onboarding Call Banner', {
      Status: this.status
    });
  }
}
